export { default as ProductsSeasonalFilterBadge } from './ProductsSeasonalFilterBadge';
